import React from "react";
import { Helmet } from "react-helmet";
import img1 from "../../../assets/thai/เสียสิทธิ1.png";
import img2 from "../../../assets/thai/เสียสิทธิ2.jpg";
import img3 from "../../../assets/thai/เสียสิทธิ3.png";

const การเสียสิทธิในมรดก = () => {
  const TITLE = "ลักษณะแบบไหน ? ถึงเรียกว่าเสียสิทธิในการรับมรดก";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การเสียสิทธิในการรับมรดก
          คือเหตุการณ์ที่ทำให้ผู้ที่มีสิทธิรับมรดก
          ไม่ว่าจะอยู่ในฐานะทายาทโดยธรรม
          หรือผู้รับพินัยกรรมก็ตามได้เสียไปซึ่งสิทธิในมรดก ซึ่งมีด้วยกัน 4
          ประการ คือ
          <ul className=" list-decimal ml-16 mt-3">
            <li>การถูกกำจัดมิให้รับมรดก</li>
            <li>การตัดมิให้รับมรดก</li>
            <li>การสละมรดก</li>
            <li>การสูญเสียมรดกโดยอายุความ</li>
          </ul>
        </p>

        {/* 1. การถูกกำจัดมิให้รับมรดก */}
        <div>
          <h2 id="initial-header">1. การถูกกำจัดมิให้รับมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การถูกกำจัดมิให้รับมรดกเป็นผลจากบทบัญญัติของกฎหมายที่ทำให้ทายาทเสียสิทธิในมรดก
            การถูกกำจัดมิให้รับมรดกมี 2 กรณี คือ{" "}
            <mark className=" bg-[#fee9b2] rounded-xl">
              การถูกกำจัดมิให้รับมรดกฐานยักยอกหรือปิดบังทรัพย์มรดก
            </mark>{" "}
            (เป็นการกระทำระหว่างทายาท กับทายาทด้วยกัน) และ
            <mark className=" bg-[#fee9b2] rounded-xl">
              การถูกกำจัดมิให้รับมรดกฐานเป็นผู้ไม่สมควร
            </mark>{" "}
            (เป็นการกระทำที่ไม่สมควรตามที่กฎหมายกำหนด)
          </p>

          {/* 1.1 การถูกกำจัดมิให้รับมรดกฐานยักยอกหรือปิดบังทรัพย์มรดก */}
          <div>
            <h3 id="second-header">
              1.1 การถูกกำจัดมิให้รับมรดกฐานยักยอกหรือปิดบังทรัพย์มรดก
            </h3>

            <h4 id="third-header">องค์ประกอบการถูกกำจัด</h4>
            <p className="ml-8">
              &nbsp;&nbsp;&nbsp;&nbsp;<b>1. ทายาทยักย้าย ปิดบังทรัพย์มรดก</b>
              <ul className=" list-disc ml-16 mt-3 mb-3">
                <li>
                  <b>การยักย้าย</b> หมายถึง การเคลื่อนย้าย
                  หรือการจำหน่ายจ่ายโอนซึ่งทรัพย์มรดก
                </li>
                <li>
                  <b>การปิดบัง</b> ได้แก่ การปกปิด
                  ไม่เปิดยอมเปิดเผยถึงทรัพย์มรดก
                </li>
              </ul>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <b>ตัวอย่างที่ 1 คำพิพากษาฎีกาที่ 2062/2492</b>{" "}
              ทายาทคนหนึ่งบอกแก่ทายาทอีกคนหนึ่งว่า
              ที่ดินแปลงหนึ่งผู้ตายได้โอนไปแล้วความจริงผู้ตายไม่ได้โอน
              แต่ทายาทคนนั้นโอนเป็นของตนเองเสีย เช่นนี้ ถือว่าเป็นการปิดบังมรดก
              ย่อมถูกกำจัดมิให้ได้รับมรดกในที่ดินแปลงนั้น
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <b>ตัวอย่างที่ 2 คำพิพากษาฎีกาที่ 1239/2506</b>{" "}
              ทายาทคนหนึ่งไปขอประกาศรับมรดกโดยไม่ระบุลงไปในบัญชีเครือญาติว่ายังมีบุคคลอื่นอีกด้วยนั้น
              ไม่ใช่เรื่องยักย้ายหรือปิดบังทรัพย์มรดก
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                2. การยักย้าย หรือปิดบัง ทายาทได้กระทำโดยกลฉ้อฉล
                หรือรู้อยู่ว่าทำให้ทายาทอื่นเสียประโยชน์ (เจตนาภายใน)
              </b>{" "}
              การที่ทายาทจำหน่ายจ่ายโอนทรัพย์มรดกเพื่อชำระหนี้ให้แก่เจ้าหนี้กองมรดก
              หรือเพื่อความสะดวกในการแบ่งปันทรัพย์มรดก
              ไม่ถือว่าทายาทมีเจตนาฉ้อฉล หรือทำให้ทายาทอื่นเสียประโยชน์
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className=" text-red-600">
                ***
                การยักย้ายปิดบังจะต้องเกิดขึ้นภายหลังที่เจ้ามรดกถึงแก่ความตายจึงจะทำให้ทายาทถูกกำจัด
                <br />
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className=" text-red-600">
                *** บุคคลซึ่งจะถูกกำจัดได้แก่ บุคคลซึ่งเป็นทายาท
                ส่วนบุคคลซึ่งมิได้เป็นทายาท เสียสิทธิในการรับมรดกไม่ได้
              </span>
            </p>

            <h4 id="fourth-header">
              ผลของการถูกกำจัดต่อทายาทซึ่งทำการยักย้ายหรือปิดบัง
            </h4>
            <p className="ml-8">
              &nbsp;&nbsp;&nbsp;&nbsp; ผลนี้ใช้ได้เพียงทายาทโดยธรรมเท่านั้น
              ไม่สามารถใช้ได้ในทายาทฐานะผู้รับพินัยกรรมมีทั้งหมด 2 กรณีดังนี้
              <ul className=" list-decimal ml-16 mt-3 mb-3">
                <li>
                  <mark className=" bg-[#fee9b2] rounded-xl">
                    ทายาทได้ยักย้ายหรือปิดบังน้อยกว่าที่ตนจะได้
                    ทายาทนั้นถูกกำจัดเท่ากับส่วนที่ตนได้ยักย้าย
                  </mark>
                </li>
                <li>
                  <mark className=" bg-[#fee9b2] rounded-xl">
                    ทายาทได้ยักย้ายหรือปิดบังมากกว่าหรือเท่ากับส่วนที่ตนจะได้
                    ทายาทจะถูกกำจัดมิให้รับมรดกทั้งหมด
                  </mark>
                </li>
              </ul>
              &nbsp;&nbsp;&nbsp;&nbsp;<b className="underline">ตัวอย่างเช่น</b>{" "}
              เจ้ามรดกมีทายาทโดยธรรมได้แก่นาย ก. และ ข.
              ซึ่งมีสิทธิในส่วนแบ่งทรัพย์มรดกเท่าๆกันซึ่งถ้าหากกองมรดกไม่ได้มีการยักย้ายหรือปิดบังหากประเมินกองมรดกออกมาแล้วจะมีทั้งหมด
              10 ส่วนแต่ปรากฏว่านาย ข. ได้ยักย้ายทรัพย์มรดกไป 2 ส่วน
              เช่นนี้ย่อมมีผลทำให้กองมรดกคงเหลือเพียง 8
              ส่วนซึ่งหากแบ่งแล้วจะได้นาย ก .และ ข. คนละ 4
              ส่วนเช่นนี้จะเห็นว่าการกระทำของนาย ข. ทำให้นาย ก. เสียประโยชน์{" "}
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;- ดังนั้น นาย ข.
              ต้องถูกกำจัดมิให้มรดกเท่ากับส่วนที่ตนได้ยักย้าย คือ 2 ส่วน ดังนั้น
              นาย ข. ก็จะได้รับมรดกเพียง 3 ส่วน นาย ก. จะได้รับมรดก 5 ส่วน กับ
              อีก 2 ส่วนจากที่นาย ข. ถูกกำจัด <br />
              &nbsp;&nbsp;&nbsp;&nbsp;- แต่ถ้านาย ข. ยักย้ายมากกว่า
              หรือเท่ากับส่วนของตนเองที่จะได้ นาย ข.
              จะเสียสิทธิในการรับมรดกทั้งหมด ดังภาพล่างนี้
              <img
                src={img1}
                alt="เสียสิทธิ1"
                className="w-9/12 block ml-auto mr-auto"
              />
            </p>
          </div>

          {/* 1.2 การถูกกำจัดมิให้รับมรดกฐานเป็นผู้ประพฤติไม่สมควร */}
          <div>
            <h3 id="fifth-header">
              1.2 การถูกกำจัดมิให้รับมรดกฐานเป็นผู้ประพฤติไม่สมควร
            </h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              ทายาทที่ถูกกำจัดมิให้รับมรดกฐานประพฤติไม่สมควร มี 5
              กรณีดังต่อไปนี้
              <ul className=" list-decimal ml-16 mt-3">
                {/* 1 */}
                <li>
                  ทายาทต้องคำพิพากษาอันถึงที่สุดว่าได้เจตนากระทำ
                  หรือพยายามกระทำให้เจ้ามรดกหรือผู้มีสิทธิได้รับมรดกก่อนตนถึงแก่ความตายโดยมิชอบด้วยกฎหมาย
                  <ul className=" list-disc ml-10 mt-3">
                    <li>
                      มูลเหตุของการกระทำได้แก่ ทายาทได้ <u>ฆ่าหรือพยายามฆ่า</u>{" "}
                      เจ้ามรดก หรือ <u>ผู้มีสิทธิได้รับมรดกก่อนตน</u>
                    </li>
                    <li>
                      <u>การฆ่า หรือพยายามฆ่า</u>{" "}
                      ทายาทจะต้องกระทำโดยไม่ชอบด้วยกฎหมาย
                    </li>
                    <li>
                      <u>ผู้มีสิทธิได้รับมรดกก่อนตน</u> ได้แก่
                      บุคคลซึ่งหากมีชีวิตอยู่จะทำให้ทายาทนั้นไม่มีสิทธิได้รับมรดก
                      ซึ่งอาจจะเป็นทายาทโดยพินัยกรรม
                      หรือทายาทโดยธรรมซึ่งอยู่ในลำดับก่อนตน
                    </li>
                    <li>
                      การเสียสิทธิให้รับมรดกกรณีนี้ เป็นการเสียสิทธิได้ทั้งก่อน
                      และหลังเจ้ามรดกถึงแก่ความตาย
                    </li>
                  </ul>
                </li>
                {/* 2 */}
                <li className="mt-3">
                  ผู้ที่ได้ฟ้องเจ้ามรดกหาว่าทำความผิดโทษประหารชีวิตและตนเองกลับต้องคำพิพากษาถึงที่สุดว่า
                  มีความผิดฐานฟ้องเท็จหรือทำพยานเท็จ
                  <ul className=" list-disc ml-10 mt-3">
                    <li>
                      ทายาทได้ฟ้องเจ้ามรดกว่ากระทำความผิดซึ่งมีโทษประหารชีวิต
                    </li>
                    <li>
                      ทายาททำพยานหลักฐานเท็จว่าเจ้ามรดกกระทำความผิดซึ่งมีโทษประหารชีวิต
                    </li>
                  </ul>
                </li>
                {/* 3 */}
                <li className="mt-3">
                  ผู้ที่รู้แล้วว่า เจ้ามรดกถูกฆ่าโดยเจตนา แต่มิได้นำความนั้นขึ้น{" "}
                  <u>ร้องเรียน</u> เพื่อเป็นทางที่จะเอาตัวผู้กระทำความผิดมาลงโทษ
                  <ul className=" list-disc ml-10 mt-3">
                    <li>
                      ทายาทรู้แล้วว่าเจ้ามรดกถูกฆ่าแต่ไม่นำความขึ้นร้องเรียน
                    </li>
                    <li>
                      ข้อความที่ทายาทไม่นำขึ้นร้องเรียน จะต้องมีความสำคัญ
                      อันจะเป็นเหตุให้เอาตัวผู้กระทำผิดมาลงโทษได้(รู้ในสิ่งที่คนอื่นไม่รู้)
                    </li>
                    <li>
                      <u>ร้องเรียน</u> หมายถึง การแจ้งข้อความ การร้องทุกข์{" "}
                    </li>
                    <li>
                      <b>ข้อยกเว้น</b> ถ้าทายาทนั้นเป็นบุคคลดังต่อไปนี้
                      ทายาทนั้นจะไม่ถูกกำจัด ได้แก่ <br />-
                      อายุยังไม่ครบสิบหกปีบริบูรณ์ <br /> -
                      เป็นคนวิกลจริตไม่สามารถรู้ผิดชอบ
                      <br />-
                      มีความสัมพันธ์กับผู้ที่ฆ่าเจ้ามรดกในฐานะที่เป็นสามีภริยา
                      ผู้บุพการี หรือผู้สืบสันดานของตนโดยตรง
                    </li>
                    <li>
                      การถูกกำจัดกรณีนี้ เป็นการถูกกำจัดภายหลังจากเจ้ามรดกตาย{" "}
                    </li>
                  </ul>
                </li>
                {/* 4 */}
                <li className="mt-3">
                  ผู้ที่ฉ้อฉลหรือข่มขู่ให้เจ้ามรดกทำ หรือเพิกถอน
                  หรือเปลี่ยนแปลงพินัยกรรมบางส่วนหรือทั้งหมดซึ่งเกี่ยวกับทรัพย์มรดกหรือไม่ให้กระทำการดังกล่าว
                  <ul className=" list-disc ml-10 mt-3">
                    <li>
                      ได้แก่ การฉ้อฉล ข่มขู่ เจ้ามรดกให้ทำ หรือไม่ให้ทำพินัยกรรม
                      หรือให้เพิกถอน(ไม่มีพินัยกรรม)
                      หรือไม่ให้เพิกถอน(มีพินัยกรรม)
                      พินัยกรรมอันเกี่ยวกับทรัพย์มรดก
                      <img
                        src={img2}
                        alt="เสียสิทธิ2"
                        className="w-9/12 block ml-auto mr-auto"
                      />
                    </li>
                    <li>
                      การฉ้อฉล ข่มขู่ จะต้องถึงขนาดที่หากไม่มีการฉ้อฉล ข่มขู่
                      เจ้ามรดกจะไม่ทำ หรือเพิกถอน หรือไม่ทำการดังกล่าวเลย
                    </li>
                    <li>
                      การฉ้อฉล ข่มขู่ จะต้องเป็นพินัยกรรมซึ่งเกี่ยวกับทรัพย์มรดก
                      ซึ่งได้แก่ พินัยกรรมอันเกี่ยวกับการสิทธิในทรัพย์มรดก
                      (พินัยกรรมอันเกี่ยวกับส่วนได้เสียในทรัพย์มรดก) เช่น
                      ได้รับหรือไม่ได้รับ ได้รับมากน้อย
                    </li>
                    <li>
                      ผู้ที่จะเสียสิทธิในการรับมรดก ได้แก่ ผู้ซึ่งทำการข่มขู่
                      หรือฉ้อฉลเจ้ามรดก ไม่ให้กระทำการดังกล่าว
                    </li>
                    <li>การถูกกำจัดในกรณีนี้ เป็นการถูกกำจัดก่อนเจ้ามรดกตาย</li>
                    <li>
                      <b>ตัวอย่าง</b>
                      <br />
                      - แดง ข่มขู่ให้เจ้ามรดกทำพินัยกรรมยกที่ดินให้แก่ตนเอง »
                      แดงย่อมเสียสิทธิถูกกำจัดมิให้รับมรดก
                      <br />- แดง
                      ข่มขู่ให้เจ้ามรดกทำพินัยกรรมยกที่ดินให้แก่บุตรของตน »
                      บุตรแดงไม่ถูกกำจัดมิให้รับมรดก เพราะมิได้เป็นผู้ข่มขู่
                      แต่พินัยกรรมฉบับนั้นอาจถูกเพิกถอนได้ในภายหลัง
                    </li>
                  </ul>
                </li>
                {/* 5 */}
                <li className="mt-3">
                  ผู้ที่ปลอม ทำลาย หรือปิดบังพินัยกรรมแต่บางส่วนหรือทั้งหมด
                  <ul className=" list-disc ml-10 mt-3">
                    <li>ได้แก่ การปลอม ทำลาย หรือปิดบังพินัยกรรม</li>
                    <li>
                      ในกรณีที่พินัยกรรมปลอม พินัยกรรมที่แท้จริงที่ถูกทำลาย
                      หรือพินัยกรรมที่ถูกปิดบังไม่มีผลบังคับได้ตามกฎหมาย เช่น
                      ตกเป็นโมฆะ ทายาทไม่ถูกกำจัด
                      เพราะไม่ก่อให้เกิดผลเสียหายอย่างใดขึ้น
                    </li>
                    <li>
                      ผู้ที่ถูกกำจัดในกรณีนี้ ได้แก่ ผู้ทำปลอม ทำลาย
                      หรือปิดบังพินัยกรรม
                    </li>
                    <li>
                      การถูกกำจัดในกรณีนี้
                      เป็นการถูกกำจัดได้ทั้งก่อนและหลังเจ้ามรดกตาย
                    </li>
                  </ul>
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* 2. การตัดมิให้รับมรดก  */}
        <div>
          <h2 id="sixth-header">2. การตัดมิให้รับมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mark className=" bg-[#fee9b2] rounded-xl">
              ทายาทที่ถูกตัดไม่ให้รับมรดกยนั้น ได้แก่ ทายาทโดยธรรม
            </mark>{" "}
            ตามมาตรา 1608 ที่บัญญัติว่า
            "เจ้ามรดกจะตัดทายาทโดยธรรมของตนคนใดมิให้รับมรดกก็ได้แต่ต้องแสดงเจตนาที่ชัดแจ้ง"
          </p>

          {/* 2.1 วิธีการตัดมิให้รับมรดก */}
          <div>
            <h3 id="seventh-header">2.1 วิธีการตัดมิให้รับมรดก</h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;วิธีการตัดมิให้รับมรดกสามารถตัดได้
              2 กรณี คือ{" "}
              <mark className=" bg-[#fee9b2] rounded-xl">
                ตัดมิให้รับมรดกอย่างชัดแจ้ง และตัดมิให้รับมรดกโดยปริยาย
              </mark>
            </p>

            {/* ตัดมิให้รับมรดกอย่างชัดแจ้ง */}
            <h4 id="eighth-header">ตัดมิให้รับมรดกอย่างชัดแจ้ง</h4>
            <p className="ml-8">
              &nbsp;&nbsp;&nbsp;&nbsp;การตัดมิให้รับมรดกอย่างชัดเจน สามารถตัดได้
              2 วิธีคือ ตัดโดยพินัยกรรม
              และตัดโดยทำหนังสือมอบให้แก่พนักงานเจ้าหน้าที่
              <ul className=" list-decimal ml-16 mt-3">
                <li>
                  <b>การตัดมิให้รับมรดกอย่างชัดเจน</b>
                  <ul className=" list-disc ml-8 mb-3">
                    <li>
                      ได้แก่ เจ้ามรดกทำพินัยกรรมตัดทายาทโดยธรรมมิให้รับมรดก
                    </li>
                    <li>
                      พินัยกรรมต้องมีผลสมบูรณ์ หรือไม่ถูกเพิกถอนในภายหลัง
                      มิเช่นนั้น จะไม่มีผลเป็นการตัดมิให้ได้รับมรดก
                    </li>
                    <li>
                      การตัดมิให้รับมรดกจะใช้ถ้อยคำอย่างใดก็ได้
                      ซึ่งทำให้มีความหมายเป็นการตัดมิให้รับมรดก
                    </li>
                  </ul>
                </li>

                <li>
                  <b>ตัดโดยทำหนังสือมอบให้แก่พนักงานเจ้าหน้าที่</b> ได้แก่
                  การทำหนังสือตัดมิให้รับมรดกต่อนายอำเภอตามระเบียบของกระทรวงมหาดไทย{" "}
                </li>
              </ul>
            </p>

            {/* ตัดมิให้รับมรดกโดยปริยาย */}
            <h4 id="nineth-header">ตัดมิให้รับมรดกโดยปริยาย</h4>
            <p className="ml-8">
              <ul className=" list-disc ml-10 mt-3 mb-3">
                <li>
                  ได้แก่{" "}
                  <mark className=" bg-[#fee9b2] rounded-xl">
                    กรณีที่เจ้ามรดกได้ทำพินัยกรรมจำหน่ายทรัพย์มรดกของตนทั้งหมด
                  </mark>{" "}
                  หากทายาทโดยธรรมคนใดไม่ได้รับทรัพย์มรดกตามพินัยกรรมนั้น
                  กฎหมายถือว่าทายาทโดยธรรมคนนั้นถูกตัดมิให้รับมรดก
                </li>
                <li>
                  ทายาทโดยธรรมซึ่งถูกตัดมิให้มรดก จะเสียสิทธิในการเป็นทายาท
                  (ไม่เป็นทายาท) ซึ่งจะมีผลเกี่ยวเนื่องกับอายุความมรดก
                </li>
                <li>
                  การตัดมิให้รับมรดกกรณีนี้
                  จะต้องไม่ปรากฏขณะที่เจ้ามรดกถึงแก่ความตายนั้น
                  มีทรัพย์มรดกนอกพินัยกรรมเกิดขึ้น(ขึ้นอยู่กับข้อความในพินัยกรรม)
                </li>
              </ul>
              &nbsp;&nbsp;&nbsp;&nbsp;<b>ตัวอย่างที่ 1</b>{" "}
              เจ้ามรดกได้เขียนพินัยกรรมโดยมีข้อความ ได้แก่{" "}
              <u>ข้าพเจ้าขอยกที่ดินให้แก่ นาย ก.</u> ,{" "}
              <u>ข้าพเจ้าขอยกบัญชีเงินฝากธนาคาร ให้แก่ นาย ข.</u> ,{" "}
              <u>ข้าพเจ้าของยกหุ้นในบริษัทกุหลาบแก้ว ให้แก่ นาย ค.</u>
              <br />
              ดังนี้ ถ้าขณะที่เจ้ามรดกถึงแก่กรรม
              มีทรัพย์มรดกเท่าที่ได้กล่าวไว้ในพินัยกรรม
              ทายาทโดยธรรมซึ่งมิได้รับมรดกตามพินัยกรรมย่อมถูกตัดมิให้รับมรดก
              แต่ถ้า ขณะที่ถึงแก่ความตายมีทรัพย์สินอื่นนอกจากที่ได้ระบุไว้
              เกิดขึ้น ย่อมไม่ถูกตัดมิให้รับมรดก
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<b>ตัวอย่างที่ 2</b>{" "}
              เจ้ามรดกได้เขียนพินัยกรรมโดยมีข้อความ ได้แก่{" "}
              <u>ข้าพเจ้าขอยกที่ดินให้แก่ นาย ก.</u> ,{" "}
              <u>ข้าพเจ้าขอยกบัญชีเงินฝากธนาคาร ให้แก่ นาย ข.</u> ,{" "}
              <u>ข้าพเจ้าของยกหุ้นในบริษัทกุหลาบแก้ว ให้แก่ นาย ค.</u> ,{" "}
              <u>
                ทรัพย์มรดกอื่นๆนอกจากที่ระบุไว้ข้างต้นที่มีอยู่ในขณะที่ถึงแก่ความตาย
                ขอยกให้แก่นาย ก. ทั้งหมด
              </u>
              <br />
              ดังนี้ ถ้าก่อนที่เจ้ามรดกจะถึงแก่กรรม เจ้ามรดกได้รับสิ่งใดมา
              ย่อมตกทอดแก่ ก. ทั้งหมดตามข้อ 4.
            </p>
          </div>

          {/* 2.2 การถอนการตัดมิให้รับมรดก */}
          <div>
            <h3 id="tenth-header">2.2 การถอนการตัดมิให้รับมรดก</h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การถอนการตัดมิให้รับมรดก
              เจ้ามรดกต้องถอนตามวิธีที่กฎหมายกำหนดเท่านั้น ซึ่งได้แก่
              ตัดมิให้รับมรดกโดยพินัยกรรม และตัดมิให้รับมรดกโดยทำเป็นหนังสือ ฯ
              <ul className=" list-decimal ml-16 mt-2">
                <li>
                  <b>ตัดมิให้รับมรดกโดยพินัยกรรม</b> จะถอนได้ก็ต่อเมื่อ
                  เจ้ามรดกทำพินัยกรรมไว้
                </li>
                <li>
                  <b>ตัดมิให้รับมรดกโดยทำเป็นหนังสือ ฯ</b>{" "}
                  เจ้ามรดกสามารถถอนได้โดยทำพินัยกรรม
                  หรือทำเป็นหนังสือถอนการตัดต่อนายอำเภอก็ได้
                </li>
              </ul>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ถ้าเจ้ามรดกถอนการตัดมิให้มรดกโดยวิธีอื่นนอกจากกฎหมายกำหนด
              ไม่ทำให้การตัดมิให้รับมรดกนั้นถูกถอนออกไป
              เพราะกฎหมายได้กำหนดวิธีการถอนการตัดไว้โดยเฉพาะแล้ว <b>เช่น</b>{" "}
              เจ้ามรดกทำลายพินัยกรรมการซึ่งตัดมิให้มรดกทิ้ง
              (ซึ่งเป็นวิธีการหนึ่งของการเพิกถอนพินัยกรรม
              แต่ไม่ใช่วิธีการถอนการตัดมิให้รับมรดก) ดังนั้น
              ทายาทก็ยังคงถูกตัดมิให้รับมรดก
            </p>
          </div>

          {/* 2.3 ผลของการถูกตัดมิให้รับมรดกต่อทายาทผู้ถูกตัด */}
          <div>
            <h3 id="eleventh-header">
              2.3 ผลของการถูกตัดมิให้รับมรดกต่อทายาทผู้ถูกตัด
            </h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผลของการถูกตัดมิให้รับมรดกต่อทายาทผู้ถูกตัด
              สามารถแยกได้ 2 กรณี ดังต่อไปนี้
              <ul className=" list-decimal ml-16 mt-2">
                <li>
                  <b>การตัดมิให้รับมรดกโดยชัดแจ้ง</b>{" "}
                  จะมีผลทำให้ทายาทนั้นเสียสิทธิในการรับมรดกตลอดไป{" "}
                  <u>ยกเว้นแต่</u> เจ้ามรดกได้เพิกถอนการตัดในภายหลัง
                </li>
                <li>
                  <b>การตัดมิให้รับมรดกโดยปริยาย</b>{" "}
                  ไม่แน่นอนว่าจะเสียสิทธิในการรับมรดกอย่างการตัดโดยชัดแจ้ง
                  แต่เมื่อใดมีทรัพย์มรดกนอกพินัยกรรมเกิดขึ้น
                  ทายาทโดยธรรมก็มีสิทธิได้รับมรดกนอกพินัยกรรมนั้น
                  (ขึ้นอยู่กับข้อความในการจำหน่ายทรัพย์มรดกในพินัยกรรม)
                </li>
              </ul>
            </p>
          </div>

          {/* 2.4 ผลของการถูกตัดมิให้รับมรดกต่อผู้สืบสันดานของทายาทที่ถูกตัด */}
          <div>
            <h3 id="twelfth-header">
              2.4 ผลของการถูกตัดมิให้รับมรดกต่อผู้สืบสันดานของทายาทที่ถูกตัด
            </h3>
            <p className="ml-4">
              <ul className=" list-disc ml-16 mt-3 mb-3">
                <li>
                  การตัดมิให้รับมรดกเป็นการตัดตลอดทั้งสาย(สายของเครือญาติ)
                  ดังนั้นจึงมีผลเป็นการตัดผู้สืบสันดานของทายาทที่ถูกตัดมิให้รับมรดกด้วย
                </li>
                <li>
                  ผู้สืบสันดานของผู้ถูกตัดมิให้รับมรดก
                  จึงไม่อาจที่จะเข้ารับมรดกแทนที่หรือสืบมรดกต่อจากทายาทที่ถูกตัดได้
                </li>
              </ul>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ตัวอย่างเช่น</b>{" "}
              เจ้ามรดกทำพินัยกรรม โดยมีข้อกำหนดพินัยกรรม ว่ายกทรัพย์มรดกให้แก่
              ค. ทั้งหมด และห้าม ข. เกี่ยวข้องกับทรัพย์มรดก โดย ก. และ ข.
              ต่างมีผู้สืบสันดานคือ A และ B ตามลำดับ แต่ก่อนที่
              เจ้ามรดกจะถึงแก่ความตาย ค. และ ข. ถึงแก่ความตายไปก่อน เช่นนี้
              กองมรดกจะตกทอดแก่ผู้ใด ?
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<u>คำตอบ</u>
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -
              จากตัวอย่างคือ ค. เป็นทายาทโดยพินัยกรรม แต่ได้ตายก่อนเจ้ามรดก และ
              ข. ก็ได้ตายก่อนเจ้ามรดกเช่นเดียวกับ ค. ทำให้ ค. และ ข.
              ไม่มีสิทธิรับมรดกจากเจ้ามรดก เพราะได้ตายไปก่อนเจ้ามรดกได้ตายไป
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - แต่
              ข. มีผู้สืบสันดาน คือ B ก็ย่อมไม่มีสิทธิได้รับมรดกเช่นเดียวกัน
              เพราะโดยพินัยกรรมแล้ว เป็นการเสียสิทธิตลอดทั้งสาย คือห้าม ข.
              เกี่ยวข้องกับมรดก
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -
              ทำให้ผู้ที่มีสิทธิรับมรดกของเจ้ามรดกคือ ก. เท่านั้น
              ส่วนผู้สืบสันดานของ ก. คือ A ก็ไม่มีสิทธิรับมรดก
              เพราะมีผู้สืบสันดานของเจ้ามรดกก่อนตนอยู่ คือ ก.
              ซึ่งคำตอบเหล่านี้สามารถแสดงได้ดังแผนภาพล่างนี้
              <img
                src={img3}
                alt="เสียสิทธิ3"
                className="w-10/12 block ml-auto mr-auto"
              />
            </p>
          </div>
        </div>

        {/* 3. การสละมรดก */}
        <div>
          <h2 id="thirteenth-header">3. การสละมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mark className=" bg-[#fee9b2] rounded-xl">
              การสละมรดกเป็นการเสียสิทธิในการับมรดก
              เนื่องจากทายาทไม่ประสงค์ที่จะรับทรัพย์มรดกของผู้ตาย
            </mark>{" "}
            ถ้าทายาทผู้นั้นเป็น{" "}
            <b>ผู้เยาว์ คนไร้ความสามารถ คนเสมือนไร้ความสามารถ</b>{" "}
            จะต้องรับความยินยอมจากบิดามารดา ผู้ปกครอง ผู้อนุบาลหรือผู้พิทักษ์
            และได้รับการอนุมัติจากศาลก่อนจึงทำให้การสละมรดกนั้นมีผล
          </p>

          {/* 3.1 ประเภทของการสละมรดก */}
          <div>
            <h3 id="fourteenth-header">3.1 ประเภทของการสละมรดก</h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ประเภทของการสละมรดกมี 2
              ประเภทท ดังนี้
              <ul className=" list-decimal ml-16 mt-3 mb-3">
                <li>
                  <b>การสละมรดกโดยไม่มีค่าตอบแทน หรือโดยเสน่หา</b> ได้แก่
                  การที่ทายาทสละมรดกโดยไม่ได้รับค่าตอบแทนจากการสละ
                </li>
                <li>
                  <b>การสละมรดกโดยมีค่าตอบแทน</b> ได้แก่
                  การที่ทายาทสละมรดกโดยได้รับค่าตอบแทนจากการสละมรดก
                  โดยค่าตอบแทนที่ทายาทได้รับมานั้นจะต้องไม่ได้มาจากส่วนหนึ่งส่วนใดของทรัพย์มรดก
                  มิเช่นนั้นจะมีลักษณะเป็นการสละมรดกเพียงบางส่วน
                  จะไม่มีผลเป็นการสละมรดก
                  แต่จะมีลักษณะเป็นการตกลงแบ่งมรดกเท่านั้น
                </li>
              </ul>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span className=" text-red-600">***</span>{" "}
              <mark className=" bg-[#fee9b2] rounded-xl">
                การที่ทายาทแสดงความประสงค์ไม่รับมรดก
                แต่ต้องการให้สิทธิในกองมรดกของตนตกทอดได้แก่บุคคลอื่นแทนตน
                เช่นนี้ไม่เป็นการแสดงเจตนาสละมรดก
                แต่มีลักษณะการโอนสิทธิในทรัพย์มรดก
              </mark>{" "}
              ซึ่งใช้บังคับได้การที่ทายาทแสดงความประสงค์ไม่รับมรดก
              แต่ต้องการให้สิทธิในกองมรดกของตนตกทอดได้แก่บุคคลอื่นแทนตน เช่นนี้
              ไม่เป็นการแสดงเจตนาสละมรดก แต่มีลักษณะการโอนสิทธิในทรัพย์มรดก
              ซึ่งใช้บังคับได้
            </p>
          </div>

          {/* 3.2 ข้อห้ามในการสละมรดก  */}
          <div>
            <h3 id="fifteenth-header">3.2 ข้อห้ามในการสละมรดก</h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;สี่ข้อห้ามในการสละมรดก
              มีดังนี้
              <ul className=" list-decimal ml-16 mt-3">
                <li>
                  <b>การสละมรดกจะสละเพียงบางส่วนไม่ได้</b>{" "}
                  เพราะการสละมรดกเพียงบางส่วนจะไม่มีผลทำให้ทายาทเสียสิทธิในการรับมรดกได้
                  อาจเป็นเพียงการแบ่งปันทรัพย์มรดกกันเท่านั้น
                </li>
                <li>
                  <b>การสละมรดกจะกระทำโดยมีเงื่อนไขหรือเงื่อนไขเวลาไม่ได้</b>{" "}
                  เพราะจะทำให้ตัวบุคคลที่จะเป็นทายาทนั้นมีฐานะเป็นทายาทไม่แน่นอน
                  และเกิดความยุ่งยากในการจัดการมรดกได้
                  เลยทำให้การสละมรดกโดยมีเงื่อนไข
                  ไม่มีผลทำให้ทายาทเสียสิทธิในการรับมรดก เช่น
                  เมื่อข้าพเจ้าถูกสลากกินแบ่งรางวัลที่ 1 ข้าพเจ้าจะสละมรดกทันที
                  เป็นต้น
                </li>
                <li>
                  <b>การสละมรดกจะสละก่อนเจ้ามรดกถึงแก่ความตายไม่ได้</b>{" "}
                  เพราะก่อนที่เจ้ามรดกจะถึงแก่ความตาย
                  สิทธิในความเป็นทายาทนั้นเป็นสิทธิเฉพาะตัว
                  ไม่อาจจะจำหน่ายจ่ายโอนให้คนอื่นได้
                  นอกจากนี้จะสละมรดกในสิ่งที่ยังไม่ตกทอดไม่ได้
                </li>
                <li>
                  <b>การสละมรดกเมื่อสละแล้วจะถอนไม่ได้</b>{" "}
                  เพราะจะทำเกิดความไม่แน่นอนในตัวบุคคลซึ่งเป็นทายาท
                  และมีความยุ่งยากในการจัดการทรัพย์มรดก
                </li>
              </ul>
            </p>
          </div>

          {/* 3.3  ผลของการสละมรดก */}
          <div>
            <h3 id="sixteenth-header">3.3 ผลของการสละมรดก</h3>
            <p className="ml-4">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผลของการสละมรดกสามารถแยกออกเป็น
              3 กรณีคือ ทายาทเป็นผู้สละมรดก, ผู้สืบสันดานของทายาทเป็นผู้สละมรดก
              และกรณีเจ้าหนี้ของทายาทผู้สละ
            </p>

            <h4 id="seventeenth-header">ผลของการสละมรดกต่อทายาทผู้สละ</h4>
            <p className="ml-8">
              &nbsp;&nbsp;&nbsp;&nbsp;มีผลทำให้ทายาทเสียสิทธิในการรับมรดก
              โดยกฎหมายให้มีผลย้อนหลังไปในเวลาที่เจ้ามรดกตาย
              แต่การที่ทายาทสละมรดกกองหนึ่งไปไม่ทำให้ทายาทเสียสิทธิในการเป็นทายาทมรดกกองอื่น
              และการสละมรดกทายาทนั้นอาจสละมรดกในฐานะหนึ่งฐานะใดก็ได้
              ถ้าทายาทมีฐานะหลายฐานะ
            </p>

            <h4 id="eighteenth-header">
              ผลของการสละมรดกต่อผู้สืบสันดานของทายาทที่สละมรดก
            </h4>
            <p className="ml-8">
              &nbsp;&nbsp;&nbsp;&nbsp;สามารถแยกพิจารณาได้ 2 กรณี คือ
              กรณีที่ทายาทโดยธรรมเป็นผู้สละ
              และกรณีที่ทายาทโดยพินัยกรรมเป็นผู้สละ
              <ul className=" list-decimal ml-16 mt-3">
                <li>
                  <b>ทายาทที่สละมรดกนั้นมีฐานะเป็นทายาทโดยธรรม</b>{" "}
                  ผู้สืบสันดานของทายาทโดยธรรมนั้นมีสิทธิสืบมรดกแทนทายาทที่ได้สละนั้นตามสิทธิของตน{" "}
                  <u>ยกเว้นแต่</u>{" "}
                  ทายาทผู้สละมรดกนั้นจะได้บอกสละมรดกแทนผู้สืบสันดานของตน
                  แต่จะทำได้เฉพาะผู้สืบสันดานของทายาทเป็นผู้เยาว์
                  คนไร้ความสามารถ เท่านั้น
                </li>
                <li>
                  <b>ทายาทที่สละมรดกนั้นมีฐานะเป็นทายาทโดยพินัยกรรม</b>{" "}
                  ผู้สืบสันดานของทายาทโดยพินัยกรรมไม่มีสิทธิที่จะสืบมรดกแทนทายาทโดยพินัยกรรม
                </li>
              </ul>
            </p>

            <h4 id="nineteenth-header">
              ผลของการสละมรดกต่อเจ้าหนี้ของทายาทผู้สละ
            </h4>
            <p className="ml-8">
              &nbsp;&nbsp;&nbsp;&nbsp;เมื่อทายาทสละมรดก
              เจ้าหนี้ของทายาทผู้สละสามารถปฏิบัติได้ดังนี้
              <ul className=" list-disc ml-16 mt-3">
                <li>
                  ถ้าการสละมรดกของทายาท ทำให้เจ้าหนี้ของทายาทเสียเปรียบ
                  เพราะไม่ได้รับชำระหนี้ทั้งหมด
                  หรือแต่บางส่วน(หรือสละมรดกหนีหนี้) เจ้าหนี้ของทายาทผู้สละมรดก
                  สามารถร้องขอให้ศาลเพิกถอนการสละมรดกนั้นได้
                  เท่าที่ตนต้องเสียหาย
                </li>
                <li>
                  เจ้าหนี้จะมีสิทธิบังคับชำระหนี้ได้ไม่เกินส่วนที่ทายาทผู้สละพึงจะได้รับ
                  และตามสิทธิของทายาทนั้น เพราะ เจ้าหนี้ของทายาทผู้สละ
                  มีสิทธิน้อยกว่าเจ้าหนี้ในกองมรดก
                </li>
                <li>
                  ภายหลังที่เจ้าหนี้ของทายาทผู้สละเพิกถอนการสละมรดกแล้ว
                  ถ้ายังมีทรัพย์มรดกเหลืออยู่
                  ทรัพย์มรดกนั้นก็จะตกทอดแก่ผู้สืบสันดานของทายาทผู้สละ
                  หรือทายาทอื่นของเจ้ามรดกต่อไป (ซึ่งการเพิกถอนการสละมรดกนี้
                  เป็นการเพิกถอนเพื่อผลประโยชน์ของเจ้าหนี้)
                </li>
              </ul>
            </p>
          </div>
        </div>

        {/* 4. การสูญเสียมรดกโดยอายุความ */}
        <div>
          <h2 id="twentieth-header">4. การสูญเสียมรดกโดยอายุความ</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การเสียสิทธิมรดกโดยอายุความ
            ซึ่งกฎหมายมีการกำหนดอายุความฟ้องคดีมรดกไว้ว่า{" "}
            <mark className=" bg-[#fee9b2] rounded-xl">
              ผู้ที่มีสิทธิรับมรดกตามกฎหมายหรือทายาทโดยธรรมของผู้ตาย
              ต้องฟ้องคดีภายใน 1 ปี นับแต่เจ้ามรดกตาย
              หรือนับแต่เมื่อทายาทได้รู้หรือควรได้รู้ถึงความตายของเจ้ามรดก
              แต่มิให้ฟ้องเกิน 10 ปี นับแต่เจ้ามรดกตาย
            </mark>{" "}
            โดยอายุความที่ฟ้องเรียกทรัพย์มรดกสามารถแบ่งได้ 3 กรณี คือ
            <u>ทายาทโดธรรมฟ้องเรียกมรดก</u>,{" "}
            <u>ผู้รับพินัยกรรมฟ้องเรียกทรัพย์มรดกตามข้อกำหนดพินัยกรรม</u>
            และ <u>เจ้าหนี้ของเจ้ามรดกฟ้องทายาท</u>
            <ul className=" list-disc ml-16 mt-3">
              <li>
                <b>ทายาทโดธรรมฟ้องเรียกมรดก</b> หมายถึง
                ทายาทโดยธรรมขอเรียกมรดกตามสิทธิของตนจากทายาทคนอื่น
                จะต้องฟ้องภายในอายุความ
                คือต้องฟ้องภายในกำหนดหนึ่งปีนับแต่เจ้ามรดกตายหรือนับแต่เมื่อทายาทโดยธรรม
                ได้รู้หรือควรรู้ถึงความตายของเจ้ามรดก แต่ต้องไม่เกิน 10
                ปีนับแต่เมื่อเจ้ามรดกตาย
              </li>
              <li>
                <b>ผู้รับพินัยกรรมฟ้องเรียกทรัพย์มรดกตามข้อกำหนดพินัยกรรม</b>{" "}
                หมายถึง
                ผู้รับพินัยกรรมฟ้องเรียกมรดกตามข้อกำหนดในพินัยกรรมที่เจ้ามรดกทำพินัยกรรมยกให้แก่ตน
                และต้องฟ้องภายในอายุความ
                คือฟ้องภายในหนึ่งปีนับแต่วันที่รู้หรือควรรู้ถึงสิทธิตามพินัยกรรมแต่ต้องไม่เกิน
                10 ปีนับแต่เมื่อเจ้ามรดกตาย
              </li>
              <li>
                <b>เจ้าหนี้ของเจ้ามรดกฟ้องทายาท</b> หมายถึง
                เจ้ามรดกมีเจ้าหนี้และเจ้าหนี้จะฟ้องทายาทให้รับผิดในหนี้ของเจ้ามรดกจะต้องฟ้องภายในอายุความ
                คือต้องฟ้องภายในหนึ่งปีนับแต่เมื่อเจ้าหนี้ได้รู้หรือควรรู้ถึงความตายของเจ้ามรดกแต่ต้องไม่เกิน
                10 ปีนับแต่เมื่อเจ้ามรดกตาย
              </li>
            </ul>
          </p>
        </div>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/thai/1">
              ทายาทในกองมรดกสามารถเป็นใครได้บ้าง
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/3">
              กรณีใดบ้างที่สามารถรับมรดกแทนที่กันได้
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/6">
              รูปแบบพินัยกรรม ใครสามารถทำพินัยกรรมได้บ้าง ?
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default การเสียสิทธิในมรดก;
